// import '../scss/main.scss'

import gsap from 'gsap';
gsap.registerPlugin(ScrollTrigger)
import barba from '@barba/core';
import Pointer from './commons/pointer.js'
import { win, setWin, setVh, setVw, isTouchDevice } from './utils/index.js'
import { onceHome, enterArchive, onceArchive, revealPost, leaveAnimation } from './animations/index.js';

const App = new function () {
	const body = document.body;

	this.init = () => {
		// Initial setup
		setWin()
		setVh()
		setVw()

		// If is Touch Device
		if (isTouchDevice) document.body.classList.add('is-touch-device')
		window.addEventListener('resize', this.onResize)

		// Pointer
		Pointer.init();

		// Initialize Masonry on the first page load
		function initMasonry() {
			var grid = document.querySelector('.grid');
			let msnry;
			if (grid) {
				msnry = new Masonry(grid, {
					columnWidth: '.grid-sizer',
					itemSelector: '.grid-item',
					gutter: '.gutter-sizer',
					horizontalOrder: true
				});
			}
		}
        initMasonry();

		// Inview
		const anims = [];
		function initScrolling() {
			gsap.utils.toArray("[data-inview]").forEach(function (elem) {
				return (
					anims.push(gsap.to(elem, {
						scrollTrigger: {
							// markers:true,
							scroller: document.querySelector('.bg-main-wrapper'),
							trigger: elem,
							start: "top 95%",
							end: "bottom 70%",
							onEnter() {
								elem.classList.add('is-inview');
							},
						}
					}))
				)
			});
		}
		initScrolling();


		// Barba hooks
		barba.hooks.beforeEnter((data) => {
			const matches = data.next.html.match(/<body.+?class="([^""]*)"/i);
			document.body.setAttribute('class', (matches && matches.at(1)) ?? '');
		});
		barba.hooks.enter((data) => {
			window.scrollTo(0, 0);

			let $newPageHead = $('<head />').html(
				$.parseHTML(
				  data.next.html.match(/<head[^>]*>([\s\S.]*)<\/head>/i)[0], // <- use data argument
				  document,
				  true
				)
			  );
		});
		barba.hooks.beforeLeave(() => {
			Pointer.hide();
			anims.forEach(anim => {
				anim.scrollTrigger.kill();
				anim.pause(0).kill();
			});
		});
		barba.hooks.after(() => {
            initMasonry();
			Pointer.init();
			initScrolling();
		});

		let oldLocation = "L191";

		// Barba
		barba.init({
			transitions: [
				{
					sync: false,
					name: 'general-transition',
					once({ next }) {
						gsap.from(next.container, { autoAlpha:0, duration: .7, ease: 'none' })
					},
					leave(data) {
						return new Promise(async resolve => {
							await gsap.to(data.current.container, {
								opacity: 0,
								duration: .5,
								ease: "power2.inOut",
							})
							.then(resolve);
						});
					},
					enter({ next }) {
						gsap.from(next.container, { autoAlpha:0, duration: .7, ease: 'none' })
					},
				},
				{
					sync: false,
					name: 'post',
					to: {
						namespace: ['post', 'page']
					},
						once({next}){
							let newLocation = next.container.dataset.location;
							
							// New Location
							let newLocation_length = newLocation.length - 1;
							newLocation = newLocation.slice(0, newLocation_length);
							let newMapRow = letterToNumber(newLocation.slice(0, 1));
							let newMapCol = newLocation.slice(1, newLocation_length);
						
							document.documentElement.style.setProperty('--selected-row', newMapRow);
							document.documentElement.style.setProperty('--selected-col', newMapCol);


							const mapPin = document.querySelector('.bg-pin-map');
							const headerLogo = document.querySelector('.bg-header-logo');
							let navLinks = document.querySelectorAll('.main-menu > .menu-item');

							const tl = gsap.timeline({
								defaults: {
									duration: .6, ease: "circ.out",
								}
							})
							const linksAnim = gsap.timeline()
							linksAnim
							.to( navLinks, { autoAlpha:1, yPercent: 0, backgroundColor: 'var(--color-grey)', stagger: .4, ease: "back.in" })
							.to( navLinks, { backgroundColor: 'var(--button-active-color)', stagger: .4 }, '<.4')
							.to( navLinks, { stagger: .4, clearProps:"all" }, '<')

							tl
							.set(navLinks, { autoAlpha:0, yPercent: 101  })
							.to( '.bg-spinner' , {opacity: 0, duration: .3} )
							.to( '.bg-layout', { opacity: 1} )
    						.from( mapPin, { y: -110, ease: 'power4.out', duration: .3, clearProps:"all" })
							// .to( '#pin-map-circle', { width: 200, height: 200, ease: 'bounce.out', duration: .2 })
							.fromTo("#circleMask", { opacity: 1, scale:.1, transformOrigin: "center center" }, { opacity: 1, scale: 300, transformOrigin: "center center", duration: 1, ease: "circ.in" }, "-=.5")
							.fromTo( headerLogo, { y: -20, opacity: 0  }, { y: 0, opacity: 1, duration: .6, clearProps:"all" }, "-=.6")
							.add(linksAnim, .4, "<")

							revealPost(next.container)
						},
						leave({ current }) {
							oldLocation = current.container.dataset.location;
							return new Promise(async resolve => {
								await gsap.to(current.container, {
									duration: .5,
									opacity: 0,
									ease: "power2.inOut",
								})
								resolve();
							});
						},
						enter({next}) {
							location(next);
							revealPost(next.container)
						},
				},
				{
					sync: false,
					name: 'home',
					to: {
						namespace: ['home']
					},
					once({next}) {
						onceHome(next);
					},
					leave({ current }) {
						oldLocation = current.container.dataset.location;
						return new Promise(async resolve => {
							await gsap.to(current.container, {
								duration: .5,
								opacity: 0,
								ease: "power2.inOut",
							})
							resolve();
						});
					},
					enter({next}) {
						location(next);
						enterArchive(next.container)
					},
				},
				{
					sync: false,
					name: 'archive',
					to: {
						namespace: ['archive']
					},
					once({next}) {
						onceArchive(next)
					},
					leave({ current }) {
						oldLocation = current.container.dataset.location;
						return new Promise(async resolve => {
							await gsap.to(current.container, {
								duration: .5,
								opacity: 0,
								ease: "power2.inOut",
							})
							resolve();
						});
					},
					enter({next}) {
						location(next);
						enterArchive(next.container)
					},
				},

			]
		});

		function location(next) {
			let e = next.container;
			let newLocation = next.container.dataset.location;
			
			// Old Location
			let oldLocation_length = oldLocation.length - 1;
			oldLocation = oldLocation.slice(0, oldLocation_length);
			
			// New Location
			let newLocation_length = newLocation.length - 1;
			newLocation = newLocation.slice(0, newLocation_length);
			let newMapRow = letterToNumber(newLocation.slice(0, 1));
			let newMapCol = newLocation.slice(1, newLocation_length);

			if ( oldLocation != newLocation ) {
				document.documentElement.style.setProperty('--selected-row', newMapRow);
				document.documentElement.style.setProperty('--selected-col', newMapCol);

				const tl = gsap.timeline()
				tl
				.to(".bg-pin-map", {
					y: "-30",
					duration: .3,
					ease: "power3.out"
				})
				.to(".bg-pin-map", {
					y: 0,
					duration: .5,
					ease: 'bounce.out',
					delay: .2
				})
			
				return tl

			} else {
			}
		}

		function letterToNumber(letter) {
			var uppercaseLetter = letter.toUpperCase();
			var ascii = uppercaseLetter.charCodeAt(0);
			if (ascii < 65 || ascii > 90) return null
			return ascii - 64;
		}

  	}

	this.onResize = () => {
		setWin()
		setVh()
		setVw()
	}

}

window.addEventListener('load', App.init)